var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"rounded-xl",attrs:{"color":"#3C5A99","height":"60","width":"60"},on:{"click":_vm.signInHandler}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-facebook")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }